import { getValidateForbiddenCharsFn, getValidateMaxLengthFn, getValidateMinLengthFn, getValidateRequiredFn, } from '.';
const defaultOptions = {};
function validateInput(input = '', options = defaultOptions) {
    const opts = Object.assign(Object.assign({}, defaultOptions), options);
    return (getValidateRequiredFn(opts.requiredOptions || {})(input) ||
        getValidateMinLengthFn(opts.minLengthOptions || {})(input) ||
        getValidateMaxLengthFn(opts.maxLengthOptions || {})(input) ||
        getValidateForbiddenCharsFn(opts.forbiddenOptions || {})(input));
}
export const validateName = (input) => validateInput(input);
export const getValidateNameFn = (options) => {
    return (input) => validateInput(input, options);
};
